import styled from "styled-components";

import { CloseButton as DsCloseButton } from "ds/Button";

export const DocDescription = styled.span`
  font-size: 12px;
  opacity: 50%;
  max-width: 100%;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

export const Divider = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: var(--mode-border-neutral-weakest);
`;

export const CloseButton = styled(DsCloseButton)`
  position: absolute;
  top: 13px;
  right: 13px;

  * {
    fill: var(--mode-vector-neutral-default);
  }
`;

export const Badge = styled.div`
  margin: 24px 0 0 24px;
  box-sizing: border-box;
  width: min-content;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 8px;
  white-space: nowrap;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  background-color: var(--mode-bg-neutral-weak);
  color: var(--mode-text-neutral-default);
  border-radius: 4px;
  & + [cmdk-input] {
    padding: 16px 24px;
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Separator = styled.div`
  width: calc(100% + 8px);
  margin-left: -8px !important;
  height: 1px;
  background-color: var(--mode-border-neutral-weakest);
  margin: 12px 0 8px;
`;

export const Container = styled.div`
  .command-k {
    * {
      box-sizing: border-box;
    }

    mark {
      all: unset;
      font-weight: 600;
    }

    [cmdk-root] {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      max-height: 492px;
      max-width: 600px;
      height: 100%;
      background: var(--mode-bg-neutral-weakest);
      border-radius: 8px;
      box-shadow: 0px 4px 8px 0px rgba(152, 160, 171, 0.4);
      border: 1px solid var(--mode-border-neutral-weakest);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      outline: none;
      z-index: 10000;
    }

    [cmdk-input] {
      box-sizing: border-box;
      border: none;
      width: 100%;
      font-size: 14px;
      padding: 24px 24px 16px 24px;
      border-radius: 8px;
      outline: none;
      color: var(--text-neutral-default-weak);
      background: var(--mode-bg-neutral-weakest);

      &::placeholder {
        color: var(--mode-text-neutral-weakest);
      }
    }

    [cmdk-item] {
      content-visibility: auto;
      cursor: pointer;
      border-radius: 8px;
      display: flex;
      align-items: center;
      gap: 16px;
      user-select: none;
      will-change: background, color;
      transition: all 150ms ease;
      transition-property: none;
      margin-bottom: 8px;
      color: var(--text-neutral-default-weak);
      font-size: 15px;
      line-height: 24px;
      padding: 2px 8px;
      margin-left: -8px;
      min-height: 24px;

      &[data-selected="true"] {
        border-radius: 4px;
        background: var(--mode-bg-neutral-weaker);
      }

      &:active {
        transition-property: background;
        border-radius: 4px;
        background: var(--mode-bg-neutral-weaker);
      }

      &:first-child {
        margin-top: 8px;
      }

      &:last-child {
        margin-bottom: 16px;
      }

      & + [cmdk-item] {
        margin-top: 4px;
      }

      svg {
        width: 18px;
        height: 18px;

        fill: var(--mode-vector-neutral-default);
        stroke: var(--mode-vector-neutral-default);
        path {
          stroke: var(--mode-vector-neutral-default);
        }
      }
    }

    [cmdk-list] {
      padding: 16px 24px 40px 24px;
      overflow: auto;
      overscroll-behavior: contain;
      scroll-padding-block-end: 40px;
      transition: 100ms ease;
      transition-property: height;
      box-shadow: inset 0px -10px 50px -50px #000;
      height: 100%;
      max-height: 394px;
    }

    [cmdk-group-heading] {
      user-select: none;
      color: var(--mode-text-neutral-weakest, #8b9397);
      font-size: 13px;
      font-weight: 600;
      display: flex;
      align-items: center;
    }

    [cmdk-empty] {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 64px;
      white-space: pre-wrap;
      color: var(--gray11);
    }

    .isVertical {
      flex-direction: column;
      align-items: flex-start;
      gap: 0;
      margin: 0 0 0 -8px;
    }
  }
`;

export const Meta = styled.span`
  display: flex;
  justify-content: center;
  margin-left: auto;
`;

export const Footer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: var(--mode-bg-neutral-weakest);
  width: 100%;
  height: 40px;
  border-top: 1px solid var(--gray6);
  gap: 8px;
  color: var(--mode-text-neutral-default-weak);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  position: absolute;
  bottom: 0;
`;

export const FooterBackWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const KBD = styled.kbd`
  display: flex;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid var(--mode-vector-neutral-weakest);
  background: var(--mode-bg-neutral-weakest);
  color: var(--mode-text-neutral-weakest);
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
`;
